import { render, staticRenderFns } from "./InviteEmployers.vue?vue&type=template&id=5b22e70b&"
import script from "./InviteEmployers.vue?vue&type=script&lang=js&"
export * from "./InviteEmployers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports